import request from '@/utils/request'
import socket from '@/utils/socket';

const { initWebSocket } = socket

export function getUser() {
    return request({
      url: '/user/info',
      method: 'get'
    })
}
export function getUserMenu() {
    return request({
      url: '/user/menu',
      method: 'get'
    })
}

export function mymylogin(form_data) {
    return request({
      url: '/user/login',
      method: 'post',
      data: form_data
    })
}

export function getcoinbalance(exchangeName, userId) {
  return request({
    url: '/getbalance?exchangeName=' + exchangeName + '&'+'user_Id='+userId,
    method: 'get'
  })
}

export function getfinancialrecords(exchangeName, userId) {
  return request({
    url: '/getfinancialrecords?exchangeName=' + exchangeName + '&'+'user_Id='+userId,
    method: 'get'
  })
}

export function getAssetValue(exchangeName, userId, symbol) {
  return request({
    url: '/getassetsvalue?exchangeName=' + exchangeName + '&'+'user_Id='+userId + '&'+'symbol='+symbol,
    method: 'get'
  })
}

// export function getEquityList() {
//   return request({
//     url: '/account/list',
//     method: 'get'
//   })
// }

export function getEquityList() {
  return request({
    url: '/account/list',
    method: 'get'
  })
}

export function getCoinPositionList(alias) {
  return request({
    url: '/account/position/getcoinposition?alias='+alias,
    method: 'get'
  })
}

export function getSpotPositionList() {
  return request({
    url: '/account/position/getspotposition',
    method: 'get'
  })
}

export function getTradesData(limit, offset) {
  return request({
    url: '/account/trade/page/?limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getOrdersData(limit, offset) {
  return request({
    url: '/account/order/page/?limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getTransfersData(limit, offset) {
  return request({
    url: '/account/transfer/page/?limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getFundingData(symbol, exchange) {
  return request({
    url: '/account/funding?symbol='+symbol + '&exchange=' + exchange,
    method: 'get'
  })
}

export function getFundingRankData(exchange) {
  return request({
    url: '/account/funding/rank?exchange='+exchange,
    method: 'get'
  })
}


export function getEquityAll(strategy) {
  return request({
    url: '/equity/all?strategy='+strategy,
    method: 'get'
  })
}

export function getEquityDetail(strategy) {
  return request({
    url: '/equity/detail?strategy='+strategy,
    method: 'get'
  })
}

export function getMargin(alias) {
  return request({
    url: '/account/margin/latest?alias='+alias,
    method: 'get'
  })
}

export function getTotalMargin(alias) {
  return request({
    url: '/account/margin/total?alias='+alias,
    method: 'get'
  })
}


export function getStrategy(server_index) {
  return request({
    url: 'strategy/strategy1?server_index='+server_index,
    method: 'get'
  })
}

export function getStrategyStatus(server_index) {
  return request({
    url: 'strategy/status?server_index='+server_index,
    method: 'get'
  })
}

export function startStrategy(strategy_setting, passwd, server_index) {
  return request({
    url: 'strategy/start1?passwd=' + passwd+'&server_index='+server_index,
    method: 'post',
    data: strategy_setting
  })
}

export function stopStrategy(strategy_name, passwd, server_index) {
  return request({
    url: 'strategy/stop?strategy_name=' + strategy_name +'&passwd='+passwd+'&server_index='+server_index,
    method: 'post'
  })
}

export function getStrategyRet(strategy) {
  return request({
    url: '/equity/wmy?strategy='+strategy,
    method: 'get'
  })
}

export function getDividendHistory(strategy) {
  return request({
    url: '/equity/dividends?strategy='+strategy,
    method: 'get'
  })
}

export function getStrategyFunding(alias) {
  return request({
    url: '/account/fundingratio?alias='+alias,
    method: 'get'
  })
}

export function transferCoin(out_exchange, in_exchange, symbol, amount, passwd, server_index) {
  return request({
    url: 'strategy/transfer?out_exchange=' + out_exchange +'&in_exchange='+in_exchange+'&symbol='+symbol+'&amount='+amount+'&passwd='+passwd+'&server_index='+server_index,
    method: 'post'
  })
}

export function getPosition(strategy) {
  return request({
    url: '/position/exchange?strategy='+strategy,
    method: 'get'
  })
}

export function getPositionList(strategy) {
  return request({
    url: '/position/list?strategy='+strategy,
    method: 'get'
  })
}

export function getCrossBalance(alias) {
  return request({
    url: '/account/balance/cross_exchange?alias='+alias,
    method: 'get'
  })
}

export function getCrossFunding(alias) {
  return request({
    url: '/account/funding_rate/cross?alias='+alias,
    method: 'get'
  })
}

export function getCrossEquity(alias) {
  return request({
    url: '/account/equity/cross?alias='+alias,
    method: 'get'
  })
}


export function getScheduler() {
  return request({
    url: '/user/risk_log',
    method: 'get'
  })
}


export function getSummaryEquity() {
  return request({
    url: '/account/equity_summary',
    method: 'get'
  })
}


export function getShowEquity(alias) {
  return request({
    url: '/account/equity_weekly?alias='+alias,
    method: 'get'
  })
}


export function getTradeBasis(limit, offset) {
  return request({
    url: '/strategy/trade_basis/page?limit='+ limit + '&offset=' + offset,
    method: 'get'
  })
}

export function getProfitDivide(strategy) {
  return request({
    url: '/account/profit/divide?strategy=' + strategy,
    method: 'get'
  })
}

export function getStrategyStats(strategy) {
  return request({
    url: '/user/stats?strategy=' + strategy,
    method: 'get'
  })
}

export function getBinanceTicks(type){
  return initWebSocket('/ws/binance/' + type + '/tick')
}